import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store/index.js';

Vue.use(VueRouter);

const otherRoute = [];

const routeContext = require.context('./modules', true, /\.js$/);

routeContext.keys().forEach(item => {
    const routeModule = routeContext(item);
    if (Object.keys(routeModule).length > 0) {
        otherRoute.push(...(routeModule.default || routeModule));
    }
});

/**
 * 需要缓存的路由在meta中添加 keepAlive: true
 * 需要登录的页面在meta中添加 needLogin: true
 * 需要显示footer在meta中添加 showFooter: true
 */
const routes = [{
        path: '/',
        name: 'layout',
        component: () => import('../layout/index.vue'),
        children: [{
                path: 'home',
                redirect: '/'
            }, {
                path: '',
                name: '首页',
                meta: {
                    showFooter: true
                },
                component: () => import('../views/home.vue')
            }, {
                path: 'login',
                name: '登录',
                meta: {
                    showFooter: true
                },
                component: () => import('../views/login/login.vue')
            }, {
                path: 'passWord',
                name: '忘记密码',
                meta: {
                    showFooter: true
                },
                component: () => import('../views/login/passWord.vue')
            }, {
                path: 'regsit',
                name: '注册',
                meta: {
                    showFooter: true
                },
                component: () => import('../views/login/regsit.vue')
            }, {
                path: 'agree',
                name: '用户服务协议',
                meta: {
                    showFooter: true
                },
                component: () => import('../views/login/agree.vue')
            }, {
                path: 'media',
                name: '媒体报道',
                meta: {
                    showFooter: true
                },
                component: () => import('../views/home/media.vue')
            }, {
                path: 'mediaDetails',
                name: '报道详情',
                meta: {
                    showFooter: true
                },
                component: () => import('../views/home/details.vue')
            }, {
                path: 'headDetails',
                name: '资讯详情',
                meta: {
                    showFooter: true
                },
                component: () => import('../views/home/headdetails.vue')
            }, {
                path: 'fuWuxq',
                name: '服务详情',
                meta: {
                    showFooter: true
                },
                component: () => import('../views/home/fuwu.vue')
            }, {
                path: 'luboxq',
                name: '录播详情',
                meta: {
                    showFooter: true
                },
                component: () => import('../views/home/lubo.vue')
            }, {
                path: 'moreList',
                name: '更多资讯',
                meta: {
                    showFooter: true
                },
                component: () => import('../views/home/more.vue')
            }, {
                path: 'zhuanjiaTo',
                name: '专家更多',
                meta: {
                    showFooter: true
                },
                component: () => import('../views/home/zhuanjia.vue')
            }, {
                path: 'huoDongTo',
                name: '活动详情',
                meta: {
                    showFooter: true
                },
                component: () => import('../views/home/huodong.vue')
            },
            {
                path: 'vip',
                name: '开通VIP',
                meta: {
                    showFooter: true
                },
                component: () => import('../views/home/vip.vue')
            },
            {
                path: 'vipPay',
                name: '支付',
                meta: {
                    showFooter: true
                },
                component: () => import('../views/home/vip_pay.vue')
            },
            // modules 其他路由
            ...otherRoute
        ]

    },
    // 错误路由
    {
        path: '/404',
        name: 'error',
        meta: {
            keepAlive: true
        },
        component: () => import('../layout/error.vue')
    }, {
        path: '*',
        redirect: '/404'
    }
];

const router = new VueRouter({
    routes
});

// 路由守卫
router.beforeEach((to, from, next) => {
    // if (to.meta.needLogin && !store.state.user.token && from.fullPath !== '/passport/login') {
    //     Message({
    //         message: '用户尚未登录，请登录',
    //         type: 'error',
    //         duration: 3 * 1000,
    //         showClose: true
    //     });
    //     next({
    //         path: '/passport/login'
    //     });
    // }

    document.title = to.name;
    if (store.state.shop.nav) {
        const item = store.state.shop.nav.find(a => a.Url === to.path);
        if (item) {
            document.title = item.Title;
        }
    }
    next();
});

export default router;
